<template>
  <div class="relative applicant_profile_modal">
    <div v-if="is_loading" class="loading"></div>
    <iframe v-else :src="pdf_src" width="100%" height="100%" class="iframe"></iframe>
  </div>
</template>
<script>
export default {
  name: 'applicant-profile-pdf',
  props: {
    payload: {
      type: Object
    }
  },
  data () {
    return {
      is_loading: true,
      pdf_src: undefined
    }
  },
  created () {
    this.$network_utils.getFile({
      file_name: this.payload.fileName,
      env: this.$settings.get({ path: 'operation_name' }),
      env_id: this.payload.company_id,
      is_contract: true
    }).then(response => {
      let blob_file = new Blob([response], { type: 'application/pdf' })
      let blob_file_url = URL.createObjectURL(blob_file)
      this.pdf_src = blob_file_url + '#toolbar=0&navpanes=0&zoom=100'
      this.is_loading = false
    })
  }
}
</script>
<style scoped>
  .applicant_profile_modal {
    min-height: 100%;
    height: 100%;
  }
  .applicant_profile_modal .iframe {
    display: block;
    height: 70vh;
  }
  </style>
